import { render } from "./IndexInfo.vue?vue&type=template&id=790f5f1b&scoped=true"
import script from "./IndexInfo.vue?vue&type=script&lang=js"
export * from "./IndexInfo.vue?vue&type=script&lang=js"

import "./IndexInfo.vue?vue&type=style&index=0&id=790f5f1b&lang=scss&scoped=true"

import exportComponent from "/Users/user/workspace/okshop-diner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790f5f1b"]])

export default __exports__